module.exports = __webpack_public_path__ + "img/white_gold.bc678d3.png";